<template>
  <div class="one-liner">
    <v-icon size="4px" class="mr-1">
      circle
    </v-icon>
    <span class="content">
      {{ thread.content }}
    </span>
    <span class="name">
      {{ getUserName(thread.userId) }}
    </span>
    <span class="date">
      {{ getFromNow(thread.replyDate) }}
    </span>
  </div>
</template>
<script>
import moment from 'moment';
import { mapGetters } from 'vuex';
import { types as usersTypes } from '../../../../store/users';

export default {
  name: 'OneLinerThread',
  props: {
    thread: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      userName: usersTypes.getters.userName,
    }),
  },
  methods: {
    getFromNow(date) {
      return moment(date).fromNow();
    },
    getUserName(userId) {
      return this.userName(userId);
    },
  },
};
</script>
<style scoped>
.one-liner {
  --font-size: 13px;
  --font-size-timestamp: 11px;
  --color: #8F979F;
}

.content {
  font-size: var(--font-size);
}

.name {
  color: var(--color);
  font-size: var(--font-size-timestamp);
}

.date {
  color: var(--color);
  font-size: var(--font-size-timestamp);
}
</style>
